import React from "react";
import { Navigate } from "react-router-dom";
import { useOnboarding } from "../../providers/onboarding-provider";
import { PageLoader } from "../page-loader";

export const OnboardingRoute = ({ component: Component, step, ...args }) => {
  const { loading, canAccessStep, getLatestStep, currentStep } = useOnboarding();

  if (loading) {
    return <PageLoader />;
  }

  // Waiting screens should not stick after the engine has advanced past them
  // (completed wait steps remain in available_steps for revisit metadata).
  const isStaleWaitStep =
    (step === "AWAIT_COUNTERSIGN" || step === "PENDING_APPROVAL") &&
    currentStep &&
    currentStep !== step;

  if (isStaleWaitStep) {
    return <Navigate to={getLatestStep()} replace />;
  }

  // If user can access this step, render the component
  if (canAccessStep(step)) {
    console.log("access to step: ", step, "is allowed");
    return <Component {...args} />;
  }

  // Otherwise, redirect to the latest available step
  console.log("redirecting to latest step: ", getLatestStep(), "since access to step: ", step, "is not allowed.");
  return <Navigate to={getLatestStep()} replace />;
};
